{
  "zh-TW": {
    "title": {
      "cart": "購物車",
      "locations": {
        "index": "地點",
        "places": "所有地點"
      },
      "default": "FleetYards.net",
      "defaultShort": "FleetYards",
      "defaultAdmin": "FleetYards.net Command",
      "defaultAdminShort": "FltYrds Command",
      "defaultDocs": "FleetYards.net Documentation",
      "defaultDocsShort": "FleetYards Docs",
      "vehiclePlaque": "%{vehicle} 的命名銘牌",
      "home": "首頁",
      "ships": {
        "index": "艦船",
        "viewer": "艦船檢視器"
      },
      "ship": "%{name} - %{manufacturer}",
      "shipImages": "%{name} 圖片",
      "shipVideos": "%{name} 影片",
      "shipHistory": "%{name} 歷史",
      "componentHistory": "%{name} 歷史",
      "shipViewer": "%{name} 檢視器",
      "itemViewer": "%{name} 檢視器",
      "images": "圖片",
      "stats": "統計",
      "login": "登入",
      "signUp": "註冊",
      "embed": "嵌入式小工具",
      "apiV1": "API V1",
      "apiV1Schema": "架構",
      "apiV1Pagination": "分頁",
      "authApiV1": "Auth API V1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "架構",
      "hangar": {
        "index": "我的機庫",
        "preview": "我的機庫預覽",
        "stats": "我的機庫統計",
        "import": "匯入",
        "public": "%{user} 機庫",
        "publicStats": "%{user} 機庫統計",
        "wishlist": "心願清單",
        "blueprints": "我的藍圖",
        "publicWishlist": "%{user} 心願清單",
        "vehicleLoadouts": "飛船裝配",
        "inventories": "My Hangar Inventories",
        "inventory": "%{inventory}",
        "vehicleCargo": "飛船貨物",
        "vehicleLoadout": "載具配置",
        "buybacks": "可回購承諾",
        "paints": "塗裝",
        "flair": "機庫裝飾",
        "upgrades": "升級 / CCU",
        "equipment": "FPS 裝備",
        "imports": "匯入記錄",
        "transfers": "轉移",
        "vehicleOverview": "艦船概覽",
        "vehicleLog": "艦長日誌",
        "shipComponents": "飛船部件",
        "plans": "機庫規劃器",
        "sharedPlan": "共享機庫計畫"
      },
      "requestPassword": "請求密碼",
      "changePassword": "更改密碼",
      "fleets": {
        "add": "建立新艦隊",
        "preview": "艦隊預覽",
        "invites": "艦隊邀請",
        "members": {
          "index": "%{fleet} Members",
          "invites": "%{fleet} Invites",
          "worldmap": "%{fleet} 成員世界地圖",
          "starmap": "%{fleet} 成員星圖",
          "health": "%{fleet} 成員健康檢查"
        },
        "squadrons": {
          "index": "%{fleet} 中隊",
          "overview": "%{fleet} 中隊總覽",
          "members": "%{fleet} 中隊成員",
          "create": {
            "details": "建立中隊 - %{fleet}",
            "appearance": "中隊外觀 - %{fleet}",
            "discord": "中隊 Discord - %{fleet}"
          },
          "edit": {
            "details": "編輯中隊 - %{fleet}",
            "appearance": "中隊外觀 - %{fleet}",
            "discord": "中隊 Discord - %{fleet}"
          }
        },
        "stats": "%{fleet} 統計",
        "blueprints": "%{fleet} 的藍圖",
        "logistics": {
          "index": "%{fleet} Logistics",
          "inventories": "%{fleet} Inventories",
          "transfers": "%{fleet} 轉移"
        },
        "shoppingLists": "%{fleet} 購物清單",
        "missions": {
          "index": "%{fleet} 任務",
          "create": "建立任務 - %{fleet}",
          "edit": {
            "details": "編輯任務 - %{fleet}",
            "teams": "編輯小隊與席位 - %{fleet}"
          },
          "show": "%{fleet} 任務"
        },
        "events": {
          "index": "%{fleet} 活動",
          "calendar": "%{fleet} 行事曆",
          "create": "建立活動 - %{fleet}",
          "edit": {
            "details": "編輯活動 - %{fleet}",
            "schedule": "編輯日程 - %{fleet}",
            "signup": "編輯報名 - %{fleet}",
            "teams": "編輯小隊與席位 - %{fleet}"
          },
          "show": "%{fleet} 活動",
          "payouts": "%{fleet} 活動分帳"
        },
        "tours": {
          "index": "%{fleet} 行程",
          "create": "建立行程 - %{fleet}",
          "show": "%{fleet} 行程"
        },
        "settings": {
          "index": "%{fleet} 設定",
          "fleet": "%{fleet} 設定",
          "rsi": "%{fleet} 艦隊 ID 與 RSI",
          "membership": "%{fleet} 成員資格",
          "roles": "%{fleet} 角色",
          "squadrons": "%{fleet} 中隊",
          "allies": "%{fleet} 盟友",
          "notifications": "%{fleet} 通知設定",
          "discord": "%{fleet} Discord 設定",
          "calendar": "%{fleet} 行事曆設定",
          "features": "%{fleet} 功能",
          "contracts": "%{fleet} 合約設定"
        },
        "contracts": {
          "index": "合約",
          "create": "建立合約",
          "edit": "編輯合約",
          "show": "合約",
          "payouts": "%{fleet} 合約分帳"
        },
        "directory": "艦隊目錄"
      },
      "roadmap": {
        "index": "路線圖",
        "ships": "艦船路線圖",
        "changes": "路線圖變更"
      },
      "settings": {
        "index": "個人設定",
        "profile": "個人資料設定",
        "account": "帳戶",
        "hangar": "機庫設定",
        "privacy": "隱私設定",
        "features": "功能標誌",
        "connections": "連線",
        "oauthApplications": "OAuth 應用程式",
        "notifications": "通知設定",
        "calendar": "行事曆訂閱",
        "donations": "捐贈",
        "security": "帳戶安全",
        "twoFactor": {
          "enable": "啟用雙因素認證",
          "disable": "停用雙因素認證",
          "backupCodes": "產生雙因素備份代碼"
        },
        "friends": "好友"
      },
      "compare": {
        "ships": "比較艦船",
        "components": "比較組件",
        "equipment": "比較裝備"
      },
      "notFound": "404",
      "tools": {
        "index": "工具",
        "travelTimes": "旅行時間",
        "cargoGrids": "貨物網格",
        "plaque": "獻詞銘牌",
        "tradeRoutes": "貿易路線",
        "dressingRoom": "試衣間",
        "paintBooth": "噴漆間",
        "tours": {
          "index": "行程",
          "add": "建立新行程",
          "show": "%{tour}",
          "join": "加入行程"
        }
      },
      "impressum": "版權聲明",
      "support": "支持",
      "share": "分享",
      "privacyPolicy": "隱私政策",
      "cookiePolicy": "Cookie政策",
      "visualTests": {
        "blueprints": "藍圖 - 視覺測試",
        "index": "視覺測試",
        "panels": "面板 - 視覺測試",
        "buttons": "按鈕 - 視覺測試",
        "events": "活動",
        "typography": "排版 - 視覺測試",
        "forms": "表單 - 視覺測試",
        "tables": "表格 - 視覺測試",
        "lists": "列表 - 視覺測試",
        "metrics": "指標 - 視覺測試",
        "states": "狀態 - 視覺測試",
        "notifications": "通知 - 視覺測試",
        "dedicationPlaques": "命名銘牌 - 視覺測試",
        "syncModal": "同步彈窗 - 視覺測試",
        "buybackSyncModal": "回購同步彈窗 - 視覺測試",
        "rsiVerificationModal": "RSI 驗證彈窗 - 視覺測試",
        "fleetRsiVerificationModal": "艦隊 RSI 驗證彈窗 - 視覺測試",
        "overlays": "覆蓋層 - 視覺測試",
        "installPrompt": "安裝提示 - 視覺測試",
        "supportHint": "支援提示 - 視覺測試",
        "media": "媒體 - 視覺測試",
        "charts": "圖表 - 視覺測試",
        "themes": "主題 - 視覺測試",
        "alerts": "提示 - 視覺測試",
        "verifiedBadges": "驗證徽章 - 視覺測試",
        "chips": "Chips - 視覺測試",
        "squadrons": "中隊 - 視覺測試",
        "notificationCenter": "通知中心 - 視覺測試"
      },
      "admin": {
        "locations": {
          "index": "地點",
          "show": "%{location}"
        },
        "blueprints": {
          "index": "藍圖",
          "show": "%{blueprint}"
        },
        "missions": {
          "index": "任務",
          "show": "%{mission}"
        },
        "models": {
          "index": "模型",
          "new": "新模型",
          "edit": {
            "index": "編輯 %{manufacturer} %{model}",
            "metrics": "編輯 %{manufacturer} %{model} 指標",
            "prices": "編輯 %{manufacturer} %{model} 價格",
            "fleetchart": "編輯 %{manufacturer} %{model} 艦隊圖表圖片",
            "positions": "編輯 %{manufacturer} %{model} 乘員位置",
            "hardpoints": "編輯 %{manufacturer} %{model} 掛載點",
            "cargoAndFuel": "編輯 %{manufacturer} %{model} 燃料",
            "cargoHolds": "編輯 %{manufacturer} %{model} 貨艙",
            "docks": "編輯 %{manufacturer} %{model} 停靠點",
            "modules": "編輯 %{manufacturer} %{model} 模組",
            "paints": "編輯 %{manufacturer} %{model} 塗裝",
            "images": "編輯 %{manufacturer} %{model} 圖片",
            "videos": "編輯 %{manufacturer} %{model} 影片",
            "loaners": "編輯 %{manufacturer} %{model} 借用",
            "snubCrafts": "編輯 %{manufacturer} %{model} 艦載小艇",
            "upgrades": "編輯 %{manufacturer} %{model} 升級",
            "packages": "編輯 %{manufacturer} %{model} 套件",
            "history": "編輯 %{manufacturer} %{model} 歷史記錄"
          }
        },
        "components": {
          "index": "組件",
          "new": "新組件",
          "edit": {
            "index": "編輯組件",
            "prices": "Edit Component Prices",
            "history": "編輯組件歷史記錄"
          }
        },
        "manufacturers": {
          "index": "製造商",
          "new": "新製造商",
          "edit": {
            "index": "編輯製造商"
          }
        },
        "announcements": {
          "index": "公告",
          "new": "新增公告",
          "edit": "編輯公告",
          "show": "公告"
        },
        "supporterContributions": {
          "index": "支持者貢獻",
          "new": "新增支持者貢獻",
          "edit": "編輯支持者貢獻"
        },
        "fundingGoals": {
          "index": "資金目標",
          "new": "新增資金目標",
          "edit": "編輯資金目標"
        },
        "homepage": "首頁",
        "gameEvents": {
          "index": "遊戲活動",
          "new": "新增遊戲活動",
          "edit": "編輯遊戲活動"
        },
        "users": {
          "index": "用戶",
          "edit": "編輯用戶",
          "inventories": "使用者庫存",
          "inventory": "使用者庫存",
          "inventoryItem": "庫存記錄",
          "fleets": "使用者艦隊",
          "supporterContributions": "使用者支持者貢獻"
        },
        "vehicles": {
          "index": "載具",
          "edit": "編輯載具"
        },
        "admins": {
          "index": "管理員",
          "new": "新增管理員",
          "edit": "編輯管理員"
        },
        "fleets": {
          "index": "艦隊",
          "edit": "編輯艦隊",
          "members": "艦隊成員",
          "memberEdit": "編輯艦隊成員",
          "history": "艦隊歷史記錄",
          "roles": "艦隊角色",
          "role": "艦隊角色",
          "inventories": "艦隊庫存",
          "inventory": "艦隊庫存",
          "inventoryItem": "庫存記錄"
        },
        "oauthApplications": {
          "index": "OAuth 應用程式",
          "new": "新增 OAuth 應用程式",
          "edit": "編輯 OAuth 應用程式"
        },
        "features": {
          "index": "功能標誌",
          "show": "功能詳情",
          "overview": "功能標誌",
          "users": "功能標誌使用者",
          "fleets": "功能標誌艦隊",
          "history": "功能標誌歷史"
        },
        "images": {
          "index": "圖片"
        },
        "notifications": {
          "index": "通知"
        },
        "maintenance": {
          "index": "維護",
          "pghero": "PgHero",
          "features": "功能",
          "flipper": "Flipper UI",
          "workers": "工作程序",
          "tasks": "任務",
          "imports": "匯入",
          "importDetail": "匯入詳情",
          "rsiApiStatus": "RSI API 狀態",
          "buildCompare": "版本比較"
        },
        "modelPaints": {
          "index": "模型塗裝",
          "edit": "編輯模型塗裝"
        },
        "modelModules": {
          "index": "模型模組",
          "edit": {
            "index": "編輯 %{name} 基本資料",
            "models": "編輯 %{name} 模型",
            "prices": "編輯 %{name} 價格",
            "hardpoints": "編輯 %{name} 掛載點",
            "docks": "編輯 %{name} 停靠點",
            "cargoHolds": "編輯 %{name} 貨艙",
            "history": "編輯模組歷史記錄"
          }
        },
        "unlistedModels": {
          "index": "未收錄的飛船"
        },
        "modelModulePackages": {
          "index": "模型模組套件"
        },
        "commodities": {
          "index": "Commodities",
          "new": "New Commodity",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "new": "New Equipment",
          "edit": {
            "index": "Edit Equipment",
            "prices": "Edit Equipment Prices"
          }
        },
        "visualTests": {
          "index": "視覺測試",
          "notifications": "通知 - 視覺測試"
        }
      },
      "notifications": "通知",
      "component": "%{name}",
      "commodity": "%{name}",
      "commodities": {
        "index": "商品"
      },
      "components": {
        "index": "部件"
      },
      "blueprints": {
        "index": "藍圖"
      },
      "missions": {
        "index": "任務"
      },
      "equipment": {
        "index": "裝備"
      },
      "equipmentItem": "%{name}"
    }
  }
}
